module.exports = __webpack_public_path__ + "img/Screen_2.0f36a25d.png";